export default __webpack_public_path__ + "static/04_Rabbit-c29d1da0e010e382ee067fb8e8d067c4.png";